export default __webpack_public_path__ + "static/media/red_no.f4b9caeb.svg";